import React, { Component } from 'react';
import { get, has } from "lodash"

import { withStepsState } from "../../../shared/containers/containerStepsState"

import FirstTitle from '../../../shared/items/static/firstTitle';
import RadioCheckButton from '../../../shared/items/controls/radioCheckButton';
import { isCurrentStep, buildStepClassName, updateOpenStepState } from "../../../shared/services/service.step"
import { staticData } from "./static.data"
import StepContentWrapper from "./../stepContentWrapper"
import StepControl from "./../stepControl"
import { steps } from "../../../shared/static.steps"
import locales from "./../../../content.json"
import "./../../../shared/services/service.step.scss"

class Water extends Component {
  constructor() {
    super();

    this.state = {
      currentStepOpened: false,
    }
  }

  componentDidMount() {
    if (isCurrentStep(this.props.currentIndex, steps.water) && !this.state.sleeep)
      this.setState({ currentStepOpened: true })
  }

  componentDidUpdate(prevProps) {
    const { currentIndex, data, onSetStepData } = this.props
    const { currentStepOpened } = this.state
    const params = {
      currentIndex: currentIndex,
      prevIndex: prevProps.currentIndex,
      stepIndex: steps.water,
      isOpen: currentStepOpened,
      handleChange: this.handleChangeOpen.bind(this),
    }

    if (currentStepOpened && !has(data, ["water"]))
      onSetStepData("water")

    updateOpenStepState({ params })
  }

  handleChangeOpen(state) {
    this.setState({
      currentStepOpened: state,
    })
  }

  render() {
    const { currentIndex, data, onUpdateStepData } = this.props
    const { currentStepOpened } = this.state
    const params = {
      className: "wrapperCurrentActivity",
      currentIndex: currentIndex,
      stepIndex: steps.water,
    }

    return currentStepOpened ?
      <div className={buildStepClassName({ params })}>

        <StepContentWrapper>
          {/* <FirstTitle>{locales[window.userLang].activity_ask}</FirstTitle> */}
          <FirstTitle>{locales[window.userLang].water_step_title}</FirstTitle>

          {
            Object.keys(staticData).map((key, index) => {
              // console.log(staticData[key])
              // console.log(staticData)
              return (
                // ''
                <RadioCheckButton
                  key={index}
                  isChecked={get(data, ["water", "value"], null) === staticData[key].value}
                  onClick={() => {
                    if (get(data, ["water", "value"], null) !== staticData[key].value) {
                      onUpdateStepData.bind(this, "water", "value", staticData[key].value)();
                      setTimeout(this.props.onToNextStep, 300);
                    }
                  }}
                  icon={staticData[key].icon}
                >
                  {staticData[key].title}
                </RadioCheckButton>
              )
            })
          }
        </StepContentWrapper>
      </div>
      : null
  }
}

export default withStepsState(Water);